import script from "./PaginasLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginasLanding.vue?vue&type=script&setup=true&lang=js"

import "./PaginasLanding.vue?vue&type=style&index=0&id=6edd6900&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6edd6900"]])

export default __exports__